module.exports = __webpack_public_path__ + "img/tarot.81790c53.png";